import axiosClient from './axiosClient';

export const authApi = {
  login(data) {
    return axiosClient.post('/login', data);
  },
  verifyToken(data) {
    return axiosClient.post('/verify-token/', data);
  },
};

export default authApi;
